import React from 'react';
import { Text, Row, Col } from 'mymoria-ui/components';
import { form } from 'data';
import { InputField, EmailField } from 'forms/fields';
import DateInputField from 'forms/fields/DateInputField';
import StyledCard from 'components/StyledCard';
import { styled } from 'mymoria-ui';

const TextContainer = styled.div`
  margin-bottom: 2rem;
`;

const StyledText = styled(Text)`
  margin-bottom: 2rem;
`;

const Customer = () => (
  <StyledCard title={form.customer.title}>
    <TextContainer>
      <StyledText>{form.customer.text1}</StyledText>
      <Text>{form.customer.text2}</Text>
    </TextContainer>
    <Row flexWrap="wrap">
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.firstName" label={form.customer.firstName} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.lastName" label={form.customer.lastName} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.street" label={form.customer.street} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.houseNr" label={form.customer.houseNr} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.code" label={form.customer.code} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <InputField name="customer.place" label={form.customer.place} />
      </Col>
      <Col width={[1, 1, 1 / 2]}>
        <DateInputField name="customer.birthDate" label={form.customer.birthDate} />
      </Col>
      <Col width={1}>
        <InputField name="customer.relationship" label={form.customer.relationship} />
      </Col>
      <Col width={1}>
        <InputField name="customer.phone" label={form.customer.phone} type="tel" />
      </Col>
      <Col width={1}>
        <EmailField name="customer.email" label={form.customer.email} type="email" />
      </Col>
    </Row>
  </StyledCard>
);

export default Customer;
